import { NotificationType } from "@transfr-inc/dashboard-components";

export const exportOrganizationsNotification = {
  type: NotificationType.info,
  message:
    "We’re preparing a download of all organization parent-child pairs. Please wait...",
  icon: ["fa-solid", "spinner"],
  iconConfig: { spin: true },
};

export const uploadingUsersNotification = {
  type: NotificationType.info,
  message: "We’re creating the uploaded users. Please wait...",
  icon: ["fa-solid", "spinner"],
  iconConfig: { spin: true },
};

export const userAccountsCreatedNotification = (count) => ({
  type: NotificationType.success,
  icon: "fa-regular fa-head-side-goggles",
  message: `${count} user accounts have been created`,
});

export const uploadUsersErrorNotification = (error) => ({
  type: NotificationType.error,
  closable: true,
  message:
    error?.data === undefined
      ? "Something went wrong. Please try again."
      : error?.data?.detail,
});
